import React from 'react'
import { useSelector } from 'react-redux'

import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import {
  fetchPreschoolSkillData,
  updatePreschoolData
} from 'app/store/actions/preschoolEntity'

import { columns } from './config'

/**
 * Skills admin page (Phase 5).
 *
 * BaseEntity wires up CRUD against the
 * /api/v1/preschool-evaluation/admin/skills/ endpoint via the
 * preschoolEntity saga.
 */
const Skills = () => {
  const skillData = useSelector(
    (state) => state.preschoolEntityReducer.preschoolSkillData
  )

  return (
    <BaseEntity
      entity={constants.PRESCHOOL_SKILL}
      label={constants.PRESCHOOL_SKILL_LABEL}
      columns={columns}
      data={skillData}
      fetchData={fetchPreschoolSkillData}
      updateEntityData={updatePreschoolData}
    />
  )
}

export default Skills
